// Built @Wed, 27 Dec 2023 03:56:16 GMT
var REPORT_EVENTS = {
  ONE_PLAY: "videoplayer_oneplay",
  ONE_OPERA: "videoplayer_oneopera",
  ONE_ERROR: "videoplayer_oneerror",
  ONE_EVENT: "videoplayer_oneevent",
  ONE_TEMP: "videoplayer_onetemp"
};
var ERROR_TYPES = {
  data: 1e3,
  // 数据错误导致的异常
  runtime: 1002,
  parse: 1004,
  network: 1003,
  no_error_handler: 9997,
  custom_error: 9998,
  other: 9999,
  notSupport: 1005
  // 浏览器不支持导致
};
var ERROR_CODES = {
  1: -499991,
  2: -499992,
  3: -499993,
  4: -499994,
  5: -499995
};
var PLAYBACK_STATE = {
  STOP: 0,
  PLAYING: 1,
  PAUSE: 2,
  ERROR: 3,
  LOADING: 4
};
var LOAD_STATES = {
  UNKNOWN: 0,
  PLAYABLE: 1,
  STALLED: 2,
  ERROR: 3
};
var ENDED_TYPE = {
  ERROR: 1,
  NEXT: 2,
  ENDED: 3,
  UNLOAD: 4,
  DESTROY: 5,
  PLAY_CATCH: 6,
  PLAY_ERROR: 7
};
var LOGTYPES = {
  RETRY: "error_retry",
  ONEERROR: "oneerror",
  ONEEVENT: "oneevent",
  ONETEMP: "onetemp"
};
var CACHE_FILE_TYPE = {
  NO_CACHE: 0,
  CACHED: 1
};
var MAX_TIME = 12 * 60 * 60 * 1e3;
var MAX_COST = 60 * 1e3 * 60;
var COMMON_KEYS = ["tag", "subtag", "device_type"];
var MIN_WAITIONG = 200;
var MAX_STALL_TIME = 60 * 1e3;
var MAX_FVT = 60 * 1e3;
var FULLSCREEN_TYPE = {
  NO_FULLSCREEN: 0,
  FULLSCREEN: 1,
  CSS: 2
};
export {
  CACHE_FILE_TYPE,
  COMMON_KEYS,
  ENDED_TYPE,
  ERROR_CODES,
  ERROR_TYPES,
  FULLSCREEN_TYPE,
  LOAD_STATES,
  LOGTYPES,
  MAX_COST,
  MAX_FVT,
  MAX_STALL_TIME,
  MAX_TIME,
  MIN_WAITIONG,
  PLAYBACK_STATE,
  REPORT_EVENTS
};
